<template>
  <div>
    <CommonTab>
      <div slot="main-menu" @click="$router.push('/')">商城首页</div>
      <ChannelTabMenu slot="other-menu">
        <CommonTabMenuItem to="/">首页</CommonTabMenuItem>
        <CommonTabMenuItem to="/">肝病资讯</CommonTabMenuItem>
        <CommonTabMenuItem to="/channel/liverDisease/compare"
          >主流药品药效对比</CommonTabMenuItem
        >
        <CommonTabMenuItem to="/channel/liverDisease/read"
          >如何阅读肝病化验单</CommonTabMenuItem
        >
      </ChannelTabMenu>
    </CommonTab>

    <router-view></router-view>
  </div>
</template>

<script>
import CommonTab from "@/components/pc/nav/CommonTab";
import ChannelTabMenu from "@components/pc/nav/ChannelTabMenu";
import CommonTabMenuItem from "@components/pc/nav/CommonTabMenuItem";
export default {
  name: "LiverDisease",
  components: {
    CommonTab,
    ChannelTabMenu,
    CommonTabMenuItem
  }
};
</script>

<style lang="stylus" scoped></style>
